import { ApiConstant } from "@/const";
import { HumpsUtils } from "@/utils";
import { ResponseApplicationType, ResponseDataList } from "@/types/service";
import { PaginationType } from "@/types/common";
import GlobalApi from "./config/api.config";

export type PayloadApplicationListType = Pick<PaginationType, "page" | "size"> & Partial<ResponseApplicationType>;

export const getApplicationList = async (payload: PayloadApplicationListType) => {
  const response = await GlobalApi.toCamel().get<ResponseDataList<ResponseApplicationType>>(
    ApiConstant.GET_APPLICATIONS,
    HumpsUtils.decamelizeKeys(payload),
  );
  if (response.ok && response.data) return response.data;

  throw response;
};
